import { FormattedMessage } from "react-intl";
import NoDataIndicator from "../../../Shared/NoDataIndicator/NoDataIndicator";
import PatientsIcon from "../../../Shared/PatientsIcon/PatientsIcon";

type SubjectsCountProps = {
  total?: number;
  extended?: boolean;
};

const SubjectsCount = ({ total, extended }: SubjectsCountProps) => {
  return (
    <div className="d-flex align-items-center font-md">
      <PatientsIcon />
      <span className="mx-sm"></span>
      {extended && (
        <>
          <FormattedMessage
            id="MANAGEMENT.STUDIES.SUBJECTS"
            defaultMessage="Subjects"
          />
          :<span className="mx-sm"></span>
          <FormattedMessage id="GLOBAL.TOTAL" defaultMessage="Total" />
          <span className="mx-sm"></span>
        </>
      )}
      {total ?? <NoDataIndicator />}
    </div>
  );
};

export default SubjectsCount;
